import React from 'react';
import { FaHome, FaCog, FaChevronRight, FaBars, FaBook } from 'react-icons/fa';
import { iconMap } from '../SideBar/SideBar';
import { useSelector } from 'react-redux';
import { manualHrefFor } from '../../utils/manualLink';

import './Header.css';

const Header = ({ title, onHomeClick, onToggleSidebar }) => {
  const Icon = iconMap[title] || FaCog;
  const session = useSelector((state) => state.session.data);
  return (
    <div className="header">
      <nav className="nav-bar">
        <div className="nav-left">
          <FaBars className="hamburger-btn" onClick={onToggleSidebar} />
          <FaHome className="home-icon clickable" onClick={onHomeClick} />
          <FaChevronRight className="nav-separator" />
          <Icon className="nav-title-icon" />
          <span className="nav-title">{title}</span>
        </div>
        <div className="nav-right">
          {/* 지금 화면의 매뉴얼 쪽을 새 탭으로 (title 이 바뀔 때 다시 그려지므로 현재 경로 기준) */}
          <a
            className="nav-manual"
            href={manualHrefFor(window.location.pathname)}
            target="_blank"
            rel="noopener noreferrer"
            title="사용자 매뉴얼 (새 탭)"
            data-testid="header-manual-link"
          >
            <FaBook className="nav-manual-icon" />
            <span className="nav-manual-text">매뉴얼</span>
          </a>
          <span className="nav-company">{session.companyName}</span>
          {session.contractYear > 0 && (
            <span className="contract-year-badge">{session.contractYear}</span>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Header;
